import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, from, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { ErisLoginService } from './eris-login.service';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ErisLoginInterceptor implements HttpInterceptor {
  constructor(private erisLoginService: ErisLoginService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Always resolve token from oidc storage — in-memory dataSource is often still null
    // on first requests after refresh, which caused intermittent 401s ("worked then didn't").
    return from(this.erisLoginService.userManager.getUser()).pipe(
      switchMap(user => {
        const token = user?.access_token || this.erisLoginService.getToken();
        if (user) {
          this.erisLoginService.ensureUser(user);
        }

        const attachToken = !!token && this.isSameOriginUrl(req);
        const request = attachToken
          ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } })
          : req;

        return next.handle(request).pipe(
          catchError((error: unknown) => {
            // Our token was rejected (session signed out, token expired, ...): re-establish it through the STS.
            if (attachToken && error instanceof HttpErrorResponse && error.status === 401) {
              this.erisLoginService.handleUnauthorized();
            }
            return throwError(error);
          })
        );
      })
    );
  }

  // Only the eRIS API gets the bearer token.
  private isSameOriginUrl(req: any) {
    if (req.url.startsWith(`${environment.baseUrl}/`)) {
      return true;
    }

    if (req.url.startsWith(`//${environment.domain}/`)) {
      return true;
    }

    if (/^\/[^\/].*/.test(req.url)) {
      return true;
    }

    return false;
  }
}
